import {removeLeadNote} from "@project/sdk/sales";
import {mutationOptions} from "@tanstack/react-query";

import {leadKeys, leadMutationKeys} from "../../../../../lead-keys";

export function removeLeadNoteMutationOptions(leadId: string) {
  return mutationOptions({
    mutationKey: leadMutationKeys.removeLeadNote,
    mutationFn: (noteId: number) => removeLeadNote(leadId, noteId),
    onSuccess: async (_result, _noteId, _onMutateResult, {client}) => {
      await client.invalidateQueries({queryKey: leadKeys.detail(leadId)});
    },
  });
}
